import * as React from "react";
import { Segment, Container } from "semantic-ui-react";

import "semantic-ui-css/semantic.min.css";

import AppHeader from "./views/AppHeader";
import QuickStartSection from "./views/QuickStartSection";
import FeaturesSection from "./views/FeaturesSection";
import TryNowSection from "./views/TryNowSection";
import ReactGA from "react-ga";

import "./App.css";

ReactGA.initialize("UA-123791717-1");

function App() {
  return (
    <div>
      <Segment
        inverted
        textAlign="center"
        style={{ minHeight: 240, padding: "0.5em 0em" }}
        vertical
      >
        <AppHeader />
      </Segment>
      <Container>
        <Segment vertical>
          <QuickStartSection />
        </Segment>
        <Segment vertical>
          <FeaturesSection />
        </Segment>
        <Segment vertical>
          <TryNowSection />
        </Segment>
      </Container>
    </div>
  );
}

export default App;
